<template>
  <div class="space-y-3">
    <label
      v-for="option in joinModeOptions"
      :key="option.value"
      :class="[
        'flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-colors',
        modelValue === option.value
          ? 'bg-purple-600/20 border-purple-500'
          : 'bg-white/5 border-white/10 hover:border-white/20'
      ]">
      <input
        type="radio"
        :value="option.value"
        :checked="modelValue === option.value"
        class="mt-1 accent-purple-500"
        @change="$emit('update:modelValue', option.value)" />
      <div class="flex-1">
        <div class="flex gap-2 items-center">
          <fa-icon :icon="option.icon" class="text-white/60" />
          <span class="font-medium text-white">{{ option.label }}</span>
        </div>
        <p class="mt-1 text-sm text-white/50">
          {{ option.description }}
        </p>
      </div>
    </label>
  </div>
</template>

<script setup>
import { CLUB_JOIN_MODE } from '@/stores/storeClubs'

defineProps({
  modelValue: {
    type: String,
    default: CLUB_JOIN_MODE.OPEN
  }
})

defineEmits(['update:modelValue'])

// Note: Invite mode hidden until implemented
const joinModeOptions = [
  {
    value: CLUB_JOIN_MODE.OPEN,
    label: 'Open',
    icon: ['fas', 'door-open'],
    description: 'Anyone can join this club freely'
  },
  {
    value: CLUB_JOIN_MODE.REQUEST,
    label: 'Request to Join',
    icon: ['fas', 'hand'],
    description: 'Members must request to join, admins approve'
  }
]
</script>
